"use client";

import { useState } from "react";
import { Button } from "@/components/primitives/Button";
import { Modal } from "@/components/primitives/Modal";
import { InvestorDeckForm } from "@/components/forms/InvestorDeckForm";
import { getFormsCopy } from "@/content/forms";
import { track } from "@/lib/analytics";
import { useLocale } from "@/lib/i18n/provider";

type Props = {
  label: string;
  variant?: "primary" | "secondary" | "ghost";
};

/** Opens the investor-deck modal. Lives in its own client island so the
 *  wrapping section can stay server-rendered. */
export function InvestorDeckCTA({ label, variant = "primary" }: Props) {
  const { locale } = useLocale();
  const forms = getFormsCopy(locale);
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        type="button"
        variant={variant}
        size="lg"
        onClick={() => {
          track("cta_clicked", { cta: "investor_deck" });
          setOpen(true);
        }}
      >
        {label}
      </Button>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title={forms.modals.investorDeck.title}
        description={forms.modals.investorDeck.description}
        size="lg"
      >
        <InvestorDeckForm />
      </Modal>
    </>
  );
}
